export const getToken = (): string => {
  const oktaTokenStorage = localStorage.getItem("okta-token-storage");
  if (!oktaTokenStorage) {
    throw new Error("getToken: okta-token-storage not found in localStorage");
  }
  const parsed: { accessToken?: { accessToken?: string } } | null = JSON.parse(oktaTokenStorage);
  if (!parsed?.accessToken?.accessToken) {
    throw new Error("getToken: accessToken missing in okta-token-storage");
  }
  return parsed.accessToken.accessToken;
};
